(() => {
  const init = () => {
    const main = document.getElementById('MainContent');
    if (!main) return;
    const sections = main.querySelectorAll(':scope > .shopify-section');
    if (!sections.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const revealTitle = (sectionEl) => {
      const title = sectionEl.querySelector('.section-title');
      if (!title) return;
      if (reduceMotion || typeof gsap === 'undefined') {
        title.style.opacity = '0.75';
        title.style.filter = 'none';
        return;
      }
      gsap.fromTo(
        title,
        { opacity: 0, filter: 'blur(20px)', y: 20 },
        { opacity: 0.75, filter: 'blur(0px)', y: 0, duration: 1, ease: 'power2.out', overwrite: true }
      );
    };

    const startObserving = () => {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              revealTitle(entry.target);
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.5 }
      );
      sections.forEach((s) => io.observe(s));
    };

    // Wait for the loading screen to dismiss before observing — otherwise
    // sections technically intersect during the opacity:0 phase, which would
    // reveal-and-unobserve every title before the user ever sees them.
    // If the loading screen isn't present (e.g., dev preview without a video),
    // fall back to observing immediately when the body's loading class clears.
    if (document.body.classList.contains('loading')) {
      window.addEventListener('loadingscreen:dismissed', startObserving, { once: true });
    } else {
      startObserving();
    }
  };

  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
